/*globals $*/
'use strict';

const getSvg = () => import("./external/functions/svg");
const getOwlCarousel = () => import("./external/functions/owl_carousel");
const getHeaderFunctions = () => import("./external/functions/header");
const getLozad = () => import("./external/functions/lozad");
const getSuffle = () => import("./external/functions/shuffle");
const getFilters = () => import("./external/functions/filters");

/* DETECT MOBILE */
var isMobile = false;
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
    isMobile = true;
}

var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = 40; //$('header').outerHeight();

$( document ).ready(function() {

    // COOKIES BUTTON
    $('#removecookie').on('click', function() {
       $('#cookie-allow').css('display', 'none');
    });

    //LOAD NAVBAR IF NEEDED
    if($("#nav-open-close").length > 0) {
        getHeaderFunctions().then(headerModule => {
            headerModule.showNavBar();
        });
    }

    //LOAD OWL CAROUSEL IF NEEDED
    /*if( $('.owl-carousel-home').length > 0 ) {
        getOwlCarousel().then(owlModule => {
            owlModule.initOwlCarouselHome();
        });
    }*/
    /*if( $('.hundreds-owl-carousel').length > 0 ) {
        getOwlCarousel().then(owlModule => {
            owlModule.initOwlCarouselBlog();
        });
    }*/
    if( $('.owl-carousel-products-home').length > 0 ) {
        getOwlCarousel().then(owlModule => {
            owlModule.initOwlCarouselProductsHome();
        });
    }
    if( $('.owl-carousel-product-looks').length > 0 ) {
        getOwlCarousel().then(owlModule => {
            owlModule.initOwlCarouselProductsLooks();
        });
    }
    

    //LOAD SVG IF NEEDED
    if($(".svg").length > 0) {
        getSvg().then(svgModule => {
            svgModule.prepareSvg();
        });
    }

    //LOAD FILTERS IF NEEDED
    if($(".filters").length > 0) {
        getFilters().then(filterModule => {
            filterModule.startFilters();
        });
    }

     $('.link-footer').click(function() {
        $('html, body').animate({
            scrollTop: $("#footer-form").offset().top
        }, 1500);
    });

     //intervalo de tiempo para calcular constantemente posicion del scroll
    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);
    

    //soon page 
    $('#open-soon-popup').click(function() {
        $('.soon-popup').addClass('show');
    });
    $('#hide-button').click(function() {
        $('.soon-popup').removeClass('show');
    });
    $('#close-soon-popup-box').click(function() {
        $('.soon-popup').removeClass('show');
    });

    //mini-banner home
    $('#close-banner-top').click(function() {
        $('#banner-top').addClass('hidden');
    });




    //VIDEOS

    var playing;
    if( $('#layer1').hasClass('playing') ){
        playing = "video1";
        $('.color-slider').addClass('invisible');
        $('.text-slider').addClass('invisible');
    } else {
        playing = "none";
    }

    $('#btvideo1').click(function() {
        if(playing == "video1"){
            $('#video1').get(0).pause();
            $('.color-slider').removeClass('invisible');
            $('.text-slider').removeClass('invisible');
            playing = "none";
        } else {
            $('#video1').get(0).play();
            $('.color-slider').addClass('invisible');
            $('.text-slider').addClass('invisible');
            playing = "video1";
        }
    });
    $('#bt-full-video').click(function() {
        $('.section__video-full').addClass('visible');
        $('#full-video').get(0).play();
    });
    $('#close-full-video').click(function() {
        $('.section__video-full').removeClass('visible');
        $('#full-video').get(0).pause(); 
    });


    /* APPEAR EFFECTS */
    $('.animatelines').each(function(){ calcularPosicion( $(this) ); });
    $('.fadeup').each(function(){ calcularPosicion( $(this) ); });


    /*  LATERAL MENU FAQ  */

    $('[id^="menu-button"]').on('click', function() {
        var id = $(this).data('id');
        if($(this).hasClass('selected')){
            closeAllFAQMenu();
        } else {
            closeAllFAQMenu();
            $(this).addClass('selected');
            //$('#menu-content' + id).slideDown();
            $('#menu-content' + id).addClass('show');
        }
    });

     /*  CM - INCHES TABLE MENU */
     $('#bt-cm').on('click', function() {
        $(this).addClass('selected');
        $('#bt-inches').removeClass('selected');
        $('#table-cm').addClass('show');
        $('#table-inches').removeClass('show');
     });
     $('#bt-inches').on('click', function() {
        $(this).addClass('selected');
        $('#bt-cm').removeClass('selected');
        $('#table-inches').addClass('show');
        $('#table-cm').removeClass('show');
     });


     /* ACCORDION EFFECT MAIN MENU */
     // prevent page from jumping to top from  # href link
    $('.menu-right li.menu-item-has-children > a').click(function(e) {
        e.preventDefault();
    });
    // remove link from menu items that have children
    $(".menu-right li.menu-item-has-children > a").attr("href", "#");
    //  function to open / close menu items
    $(".menu-right a").click(function() {
        var link = $(this);
        var closest_ul = link.closest("ul");
        var parallel_active_links = closest_ul.find(".active")
        var closest_li = link.closest("li");
        var link_status = closest_li.hasClass("active");
        var count = 0;

        closest_ul.find("ul").slideUp(function() {
            if (++count == closest_ul.find("ul").length)
                    parallel_active_links.removeClass("active");
        });

        if (!link_status) {
            closest_li.children("ul").slideDown();
            closest_li.addClass("active");
        }
    });


    /* ACCORDION EFFECT GENERAL */

    $(".accordion .accordion-head").click(function() {
        var link = $(this);
        var closest_ul = link.closest("ul");
        var parallel_active_links = closest_ul.find(".active")
        var closest_li = link.closest("li");
        var link_status = closest_li.hasClass("active");
        var count = 0;

        closest_ul.find(".accordion-body").slideUp(function() {
            if (++count == closest_ul.find(".accordion-body").length)
                    parallel_active_links.removeClass("active");
        });

        if (!link_status) {
            closest_li.children(".accordion-body").slideDown();
            closest_li.addClass("active");
        }
    });

    // manage filters popup
    $('#bt-filter').click(function() {
        $('.filters').addClass('show');
    });
    $('#hide-button-close-filters').click(function() {
        $('.filters').removeClass('show');
    });
    $('#close-filters').click(function() {
        $('.filters').removeClass('show');
    });
    // manage product sizeguide popup
    $('#size-guide').click(function() {
        $('.product-sizeguide').addClass('show');
    });
    $('#hide-button-close-product-sizeguide').click(function() {
        $('.product-sizeguide').removeClass('show');
    });
    $('#close-product-sizeguide').click(function() {
        $('.product-sizeguide').removeClass('show');
    });


    // animate INSTAGRAM
    /* 
    setInterval(function(){ animateInstagram( $('#insta-box1') ); }, 6000);

    setTimeout(function() {
        setInterval(function(){ animateInstagram( $('#insta-box2') ); }, 8000);
    }, 2000);
    setTimeout(function() {
        setInterval(function(){ animateInstagram( $('#insta-box3') ); }, 8000);
    }, 4000);
    setTimeout(function() {
        setInterval(function(){ animateInstagram( $('#insta-box4') ); }, 8000);
    }, 6000);
    */


    $(".shop_table .qty").on("change paste keyup", function() {
       $("button[name='update_cart']").addClass('hundreds__pink-button');
    });

    $(".coupon #coupon_code").on("change paste keyup", function() {
       $("button[name='coupon_code']").addClass('hundreds__pink-button');
    });

});

$(window).scroll(function(){ 
    didScroll = true;

    var st = $(window).scrollTop();

    if (st > 50 ) {
        $('.soon-flecha-scroll').addClass('hide');
    } else {
        $('.soon-flecha-scroll').removeClass('hide');
    }
/*
    if($('#fullpage1').length ) {
        var numberofsections = $('#fullpage1').data('id');
        var ontop = $('#fullpage1').offset().top;
        var fullheight = $('#fullpage1').height();
        var sectionheight = $('#fullpage1').height() / numberofsections;
        var portionscroll = $('#fullpage1').height() / (numberofsections + 1); //hago esto porque /3 no da tiempo a ver el ultimo frame
        var onbottom = $('#fullpage1').offset().top + (fullheight - sectionheight);
    }

    if (window.innerWidth > 900 && $('#fullpage').length ) {

        //fijar la seccion al top en cuanto toque el top
        if($('#fullpage1').length && st > ontop && st < onbottom){
            $('#fullpage1').addClass('onTop');
        } else {
            $('#fullpage1').removeClass('onTop');
        }
        //quitar fijacion al top y pegar el contenido al bottom cuando llegue al bottom
        if($('#fullpage1').length && st > onbottom ){
            $('#fullpage1').addClass('onBottom');
        } else {
            $('#fullpage1').removeClass('onBottom');
        }
         //calculat la seccion exacta en la que está para mostrat/ocultar contenido
        if($('#fullpage1').length && st > ontop && st < (ontop + portionscroll) ){
            $('#fullpage1').addClass('step1');
            $('#fullpage1').removeClass('step2');
            $('#fullpage1').removeClass('step3');
        } else if($('#fullpage1').length && st > (ontop + portionscroll) && st < (ontop + (portionscroll*2)) ){
            $('#fullpage1').addClass('step2');
            $('#fullpage1').removeClass('step1');
            $('#fullpage1').removeClass('step3');
        } else if($('#fullpage1').length && st > (ontop + (portionscroll*2)) && st < (ontop + (portionscroll*3)) ){
            $('#fullpage1').addClass('step3');
            $('#fullpage1').removeClass('step1');
            $('#fullpage1').removeClass('step2');
        }
        
    }
*/

    $('.animatelines').each(function(){ calcularPosicion( $(this) ); });
    $('.fadeup').each(function(){ calcularPosicion( $(this) ); });
});
$(window).resize(function(){ });

//Lazy load of all the images
document.addEventListener('DOMContentLoaded', function(){
    if($(".lozad").length > 0) {
        getLozad().then(lozadModule => {
            lozadModule.lozadLoad();
        });
    }

    //LOAD SHUFFLE IF NEEDED
    if($(".shuffle").length > 0) {
        getSuffle().then(suffleModule => {
            suffleModule.startShuffle();
        });
    }

    //LOAD SHUFFLE IF NEEDED
    if($(".shuffleProjects").length > 0) {
        getSuffle().then(suffleModule => {
            suffleModule.startShuffleProjects();
        });
    }
});

function hasScrolled() {
    var st = $(window).scrollTop();
    // Make sure they scroll more than delta
    /*if(Math.abs(lastScrollTop - st) <= delta)
        return;*/

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    /*if (st > lastScrollTop && st > navbarHeight){
        // Scroll Down
        //$('header').removeClass('nav-down').addClass('nav-up');
        $('.header').addClass('fixed');
    } else {
        // Scroll Up
        if(st + $(window).height() < $(document).height()) {
            //$('header').removeClass('nav-up').addClass('nav-down');
            $('.header').removeClass('fixed');
        }
    }*/

    if (st > navbarHeight){
        $('.header').addClass('fixed');
    } else {
        $('.header').removeClass('fixed');
    }

    //lastScrollTop = st;
}

function calcularPosicion(element) {
    var alto = $(window).height() - 10;
    var wScroll = $(window).scrollTop();

    if(element.length && (element.offset().top - alto) < wScroll ){
        element.addClass('show');
        //element.removeClass('notshow');
    }
}
function moveVertically(element) {
    var st = $(window).scrollTop();
    var movimiento = (st - element.offset().top) / 10;

    element.css('transform','translateY('+ movimiento +'px)');
}

function closeAllFAQMenu() {
    //$('[id^="menu-content"]').slideUp();
    $('[id^="menu-content"]').removeClass('show');
    $('[id^="menu-button"]').removeClass('selected');
}
function animateInstagram (element){
    if(! element.hasClass('step1') ){
        element.addClass('step1');
        return;
    } 
    if(element.hasClass('step1') ){
        if(! element.hasClass('step2') ){
            element.addClass('step2');
            return;
        }
    }
    if( element.hasClass('step2') ){
         element.removeClass('step1');
         element.removeClass('step2');
         return;
    }
}